import { useMemo } from 'react';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import MarketingNav, { MARKETING_NAV_LANGUAGES, getMarketingNavLanguagesContent } from 'marketplace-ui-common/components/MarketingNav';
import { getCmsHubPricingUrl, getRootUrl } from '../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export default function App({
  children
}) {
  const hydratedLanguagesContent = useMemo(() => {
    return getMarketingNavLanguagesContent(Object.keys(MARKETING_NAV_LANGUAGES).reduce((final, languageCode) => {
      final[languageCode] = getRootUrl(languageCode);
      return final;
    }, {}));
  }, []);
  const headerContentBlob = useMemo(() => {
    return {
      upperNavContent: {
        regionalDropdownContent: {
          languagesContent: hydratedLanguagesContent
        }
      },
      mobileNavContent: {
        languagesContent: hydratedLanguagesContent
      },
      navCta: {
        navCtaUrl: getCmsHubPricingUrl()
      }
    };
  }, [hydratedLanguagesContent]);
  return /*#__PURE__*/_jsx(UIFlex, {
    align: "stretch",
    "data-test-id": "app",
    direction: "column",
    style: {
      minHeight: '100vh'
    },
    children: /*#__PURE__*/_jsx(MarketingNav, {
      enableConvertFlag: true,
      headerContentBlob: headerContentBlob,
      children: /*#__PURE__*/_jsx(UIBox, {
        grow: 1,
        shrink: 1,
        children: children
      })
    })
  });
}